import Navbar from './components/Navbar';
import Hero from './components/Hero';
import QuickActionPanel from './components/QuickActionPanel';
import SmartServiceSelector from './components/SmartServiceSelector';
import ServicesSection from './components/ServicesSection';
import TechHighlight from './components/TechHighlight';
import BeforeAfter from './components/BeforeAfter';
import Testimonials from './components/Testimonials';
import CampaignSection from './components/CampaignSection';
import ContactCTA from './components/ContactCTA';
import Footer from './components/Footer';
import FloatingElements from './components/FloatingElements';

export default function Home() {
  return (
    <div className="min-h-screen font-sans" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <Navbar />
      <main>
        {/* Hero Section */}
        <Hero />
        {/* Quick Action Panel */}
        <QuickActionPanel />
        {/* Smart Service Selection */}
        <SmartServiceSelector />
        {/* Services Section */}
        <ServicesSection />
        {/* Special Technology Highlight */}
        <TechHighlight />
        {/* Before / After Slider */}
        <BeforeAfter />
        {/* Social Proof */}
        <Testimonials />
        {/* Campaign Section */}
        <CampaignSection />
        {/* Contact / CTA */}
        <ContactCTA />
      </main>
      <Footer />
      {/* Floating Elements */}
      <FloatingElements />
    </div>
  );
}
